module.exports = __webpack_public_path__ + "static/img/img_cat_36.b20645c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_cat_36.png
// module id = 540
// module chunks = 1